import i18n from "src/i18n/config";
import { z } from "zod";

export const emailConfigValidationSchema = z
    .object({
        mailService: z.enum(["smtp", "mailjet"]),
        senderMail: z.string(),
        senderName: z.string(),
        smtpHost: z.string().optional(),
        smtpPort: z.union([z.string(), z.number()]).optional(),
        smtpUser: z.string().optional(),
        smtpPassword: z.string().optional(),
        mailjetApiUser: z.string().optional(),
        mailjetApiPass: z.string().optional(),
        mailjetHookCredentials: z.string().optional(),
    })
    .superRefine((data, ctx) => {
        const senderMailMsg = i18n.t("pages:adminEmailPage.validation.senderMail");
        const senderNameMsg = i18n.t("pages:adminEmailPage.validation.senderName");

        const senderMail = data.senderMail.trim();
        if (!senderMail) {
            ctx.addIssue({ code: "custom", message: senderMailMsg, path: ["senderMail"] });
        } else if (!z.email().safeParse(senderMail).success) {
            ctx.addIssue({ code: "custom", message: senderMailMsg, path: ["senderMail"] });
        }

        if (!data.senderName.trim()) {
            ctx.addIssue({ code: "custom", message: senderNameMsg, path: ["senderName"] });
        }

        if (data.mailService === "smtp") {
            if (!data.smtpHost?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.smtp.validation.hostRequired"),
                    path: ["smtpHost"],
                });
            }

            const portStr = String(data.smtpPort ?? "").trim();
            if (!portStr) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.smtp.validation.portRequired"),
                    path: ["smtpPort"],
                });
            } else {
                const portNumber = typeof data.smtpPort === "string" ? Number(data.smtpPort) : data.smtpPort;
                if (Number.isNaN(portNumber) || (portNumber !== undefined && (portNumber <= 0 || portNumber > 65535))) {
                    ctx.addIssue({
                        code: "custom",
                        message: i18n.t("pages:adminEmailPage.service.smtp.validation.portInvalid"),
                        path: ["smtpPort"],
                    });
                }
            }

            if (!data.smtpUser?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.smtp.validation.userRequired"),
                    path: ["smtpUser"],
                });
            }

            if (!data.smtpPassword?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.smtp.validation.passwordRequired"),
                    path: ["smtpPassword"],
                });
            }
        }

        if (data.mailService === "mailjet") {
            if (!data.mailjetApiUser?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.mailjet.validation.keyRequired"),
                    path: ["mailjetApiUser"],
                });
            }

            if (!data.mailjetApiPass?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.mailjet.validation.passwordRequired"),
                    path: ["mailjetApiPass"],
                });
            }

            if (!data.mailjetHookCredentials?.trim()) {
                ctx.addIssue({
                    code: "custom",
                    message: i18n.t("pages:adminEmailPage.service.mailjet.validation.hookCredentialsRequired"),
                    path: ["mailjetHookCredentials"],
                });
            }
        }
    });
